export const PERMISSIONS = 'permissions';

export const PERMISSIONS_ACTIONS_NAME = {
  getPermissions: `${PERMISSIONS}/getPermissions`,
};

export const PERMISSIONS_MUTATIONS_NAME = {
  setPermissions: `${PERMISSIONS}/setPermissions`,
};

export const PERMISSIONS_GETTERS_NAME = {
  getPermissions: `${PERMISSIONS}/getPermissions`,
};
